<div class="card">
  <div class="row">
    <div class="col">
      <div class="form-floating" style="width:100%">
        <input id="GrundSelect" style="width:100%" class="form-control" [ngModel]="selection" (ngModelChange)="selectionChange.emit($event)"
               [ngbTypeahead]="Items"
               [inputFormatter]="formatter"
               [resultFormatter]="formatter"
               [selectOnExact]="true" />

        <label for="GrundSelect">Kasse</label>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-4">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="Name" readonly disabled [ngModel]="selection?.name">
          <label for="Name">Name</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="IK" readonly disabled [ngModel]="selection?.ik">
          <label for="IK">IK</label>
        </div>
      </div>
    </div>
  </div>
</div>
